import { render, staticRenderFns } from "./AddressHistoryApplicantName.vue?vue&type=template&id=2a3d49b0&"
import script from "./AddressHistoryApplicantName.vue?vue&type=script&lang=js&"
export * from "./AddressHistoryApplicantName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports